import sum from 'lodash/sum'
import { DashboardUtilsBag } from '@tiary-inc/tiary-shared'

export const getBaseCosts = (bag: DashboardUtilsBag): number => {
  const { pricing } = bag
  return sum([pricing.packaging, pricing.pickAndPack, pricing.shipping])
}
